<script setup lang="ts"></script>

<template>
  <div class="flex flex-wrap text-xs sm:text-sm mb-6 items-end xl:mb-4">
    <slot></slot>
  </div>
</template>
